import { useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { addToCart, removeFromCart } from '../../redux/actions/cartAction';
import MessageBox from '../../Component/MessageBox';
import Button from '../../Component/Button/index';
import { getImageSrc } from '../../utils/imageUrl';

import './cartScreen.less';

interface RootState {
  cart: {
    cartItems: any[];
  };
}

export default function CartScreen() {
  const cart = useSelector((state: RootState) => state.cart);

  const { cartItems } = cart;
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const navigate = useNavigate();

  const { id } = useParams();

  const qty = location.search ? Number(location.search.split('=')[1]) : 1;



  useEffect(() => {

    // You can dispatch an action here if needed, e.g., to fetch cart details
    if (id) {
      dispatch(addToCart(id, qty));
    }
  }, [dispatch, id, qty]);

  const removeFromCartHandler = id => {

    dispatch(removeFromCart(id));
    return;
  };




  const checkoutHandler = () => {

    navigate('/shipping');
  };

  return (
    <div className="products top">
      <div className="col-2">
        <h1>Shopping Cart</h1>
        {cartItems.length === 0 ? (
          <MessageBox>
            Cart is empty. <Link to="/">Go Shopping</Link>
          </MessageBox>
        ) : (
          <ul>
            {cartItems.map(item => (
              <li key={item.product}>
                <div className="products">
                  <div>
                    {/* <img src={item.imagen} alt={item.name} className="small" /> */}
                    <img src={getImageSrc(item.imagen || item.image)} alt={item.name} className="small" />
                  </div>
                  <div className="min-30">
                    <Link to={`/product/${item.product}`}>{item.name}</Link>
                  </div>
                  <div>
                    <select
                      value={item.qty}
                      onChange={e =>
                        dispatch(
                          addToCart(item.product, Number(e.target.value))
                        )
                      }
                    >
                      {[...Array(item.countInStock).keys()].map(x => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>${item.price}</div>
                  <div>
                    <button
                      type="button"
                      onClick={() => removeFromCartHandler(item.product)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="colo-1">
        <div className="card-detail card-body">
          <ul>
            <li>
              <h2>
                Subtotal ({cartItems.reduce((a, c) => a + c.qty, 0)} items) : $
                {cartItems.reduce((a, c) => a + c.price * c.qty, 0)}
              </h2>
            </li>
            <li>

              <Button onClick={checkoutHandler}> Proceed to CheckOut</Button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
